<template>
  <div class="sheetRowActionBar">
    <button class="iconButton check" :disabled="!showSave" @click="onSave">
      {{ $t('receiptMatcher.savePosition') }}
    </button>
    <button class="iconButton arrowUp" :disabled="!showImport" @click="onImport">
      {{ $t('receiptMatcher.importPosition') }}
    </button>
    <button class="iconButton create" :disabled="!showCreate" @click="onCreate">
      {{ $t('receiptMatcher.createPosition') }}
    </button>
    <button class="iconButton ignore" :disabled="!showIgnore" @click="onIgnore">
      {{ $t('receiptMatcher.ignorePosition') }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'SheetRowActionBar',
  props: {
    showSave: {
      type: Boolean,
      default: false,
    },
    showImport: {
      type: Boolean,
      default: false,
    },
    showIgnore: {
      type: Boolean,
      default: false,
    },
    showCreate: {
      type: Boolean,
      default: false,
    }
  },
  methods: {
    onSave() {
      if (!this.showSave) return
      this.$emit('save')
    },
    onImport() {
      if (!this.showImport) return
      this.$emit('import')
    },
    onIgnore() {
      if (!this.showIgnore) return
      this.$emit('ignore')
    },
    onCreate() {
      if (!this.showCreate) return
      this.$emit('create')
    },
  },
}
</script>

<style scoped>
.sheetRowActionBar {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 20px;
  margin-top: 16px;
  padding-top: 12px;
  border-top: 1px solid #333;
}

/* The global button.iconButton styles (main.css) provide the base look.
   These scoped rules add the icon for the check (save), arrow-up
   (import) and close (ignore) buttons, since they are not defined globally. */
.sheetRowActionBar button.iconButton.check:before {
  background-image: url("../../assets/img/icon-check.svg");
}

.sheetRowActionBar button.iconButton.arrowUp:before {
  background-image: url("../../assets/img/icon-arrow-up.svg");
}

.sheetRowActionBar button.iconButton.ignore:before {
  background-image: url("../../assets/img/icon-subtract.svg");
}

.sheetRowActionBar button.iconButton.create:before {
  background-image: url("../../assets/img/icon-add.svg");
}


.sheetRowActionBar button.iconButton:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>